// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/urkundenuebergabe-umweltpakt-bayern/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const urkundenuebergabeUmweltpaktBayernDE: PageEntry = {
  id: "post.urkundenuebergabe-umweltpakt-bayern",
  locale: "de",
  slug: "urkundenuebergabe-umweltpakt-bayern",
  seo: {
    title: "Urkundenübergabe Umweltpakt Bayern | Dietz GmbH",
    description: "Urkundenübergabe Umweltpakt Bayern",
  },
  type: "post",
  h1: "Urkundenübergabe Umweltpakt Bayern",
  blocks: [
    { kind: "heading", level: 2, text: "Urkundenübergabe Umweltpakt Bayern" },
    { kind: "paragraph", text: "Als Dank und Anerkennung für unser Engagement und die Teilnahme am Umweltpakt Bayern überreichte uns am 12. April Landrat Sebastian Straubel gemeinsam mit dem Oberbürgermeister der Stadt Neustadt Frank Rebhan und Betül Karaman von der Wirtschaftsförderung im Landratsamt ganz offiziell die Urkunde." },
    { kind: "paragraph", text: "Wir sind sehr stolz darauf und danken recht herzlich für diese Auszeichnung." },
    { kind: "paragraph", text: "Bereits seit 2020 sind wir Mitglied im Umweltpakt Bayern – eine Kooperation der Bayrischen Staatsregierung und der bayrischen Wirtschaft. Damit haben wir einen schnellen Zugang zu praxisnahen Informationen rund um den betrieblichen Umweltschutz und können an Projekten teilnehmen, die uns im Bereich Umwelt weiterbringen. Beginnend mit unserer Umweltwoche im März legten wir bereits erste Grundsteine für weitere spannende Projekte." }
  ],
};
